import { AsyncPipe } from '@angular/common';
import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { AutomatickThemePreferenceService } from '@automatick/shared-presentation-ng';
import { LoadingService, ProgressBarComponent } from '@seech/ux-ng';
import {
  asyncScheduler,
  distinctUntilChanged,
  observeOn,
  startWith,
} from 'rxjs';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [AsyncPipe, RouterOutlet, ProgressBarComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
})
export class AppComponent {
  private readonly loadingService = inject(LoadingService);
  private readonly themePreferenceService = inject(
    AutomatickThemePreferenceService,
  );
  readonly isLoading$ = this.loadingService.isLoading.pipe(
    observeOn(asyncScheduler),
    startWith(false),
    distinctUntilChanged(),
  );

  constructor() {
    this.themePreferenceService.initialize();
  }
}

export { AppComponent as App };
